import { pluginToken } from '@zodios/plugins';
import { env } from 'config/env';

import { createApiClient } from './__GENERATED';
import { getUser } from './OIDC/api';

const apiClient = createApiClient(env.VITE_API_BASE);

// Inject the OIDC bearer token on every request. oidc-client-ts manages
// token refresh and expiry internally, so resolving the user per-call
// gives us a fresh access token without having to cache it ourselves.
apiClient.use(
  pluginToken({
    getToken: async () => (await getUser())?.access_token,
  }),
);

export { apiClient };
